app.ui.registerUi('autocomplete', function(app) {
	var helpers = app.helpers.funcs;
	return {
		implementationExists: function() {
			return jQuery.fn.jdaAutocomplete ? true : false;
		},
        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },
		init: function($scope) {
			if (!this.implementationExists()) return;
			var scope = this;
			var $acElems = helpers.resolveScope('input.jda-autocomplete-seed', $scope);
			if (app.data.get('config.autocompleteBars')) {
				$acElems.each(function(elemK, elem) {
					$(elem).on('jdaAutocomplete.dropdownShown', function(e, data) {
						data.$rootElem.addClass('has-custom-scrollbar');
						data.$rootElem.find('.suggestions').wrap('<div class="nano"><div class="nano-content"></div></div>');
						setTimeout(function() {
							app.initScroll(data.$rootElem);
						}, 200);
					});
				});
			}
			$acElems.jdaAutocomplete({
				isIeFunc: helpers.isIe
			});
		}
	};
});
